import { colorProcess } from './colors';
import layout from './components/layout';
import fetchData from './fetch/fetch';
import params from './params';

export const globalData = {}

//CHECK FOR SESSION WIDGET LOAD
const waitForSessionWidget = () => {
    return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
            const sessionObject = localStorage.getItem('hydra')
            if (sessionObject && JSON.parse(sessionObject)?.['session-widget']?.session) {
                clearInterval(interval)
                resolve()
            }
        }, 20)
    })

}

const initChathead = async () => {

    const { chead, cheadKey } = params();

    if (!chead || !cheadKey) {
        return
    }

    await waitForSessionWidget()

    globalData = await fetchData()

    if (!globalData?.key) {
        return
    }

    colorProcess()
    layout()

}

initChathead();


